export const environment = {
  production: true,
  apiVersion: '0.5-Milestone',
  analyticsId: 'UA-148076361-1'
};
